
<h2 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <span>{{module + '.PURCHASE_ORDER.POPUP.ERROR_NOA_TITLE' | translate}}</span>
  <button mat-raised-button (click)="showTable = !showTable">{{ module + '.PURCHASE_ORDER.POPUP.SEE_DETAIL' | translate }}</button>
</h2>

<mat-dialog-content *ngIf="showTable">
  <mat-table [dataSource]='dataSource' class="mat-elevation-z1">
    <ng-container matColumnDef='poNumber'>
      <mat-header-cell *matHeaderCellDef> {{module + '.PURCHASE_ORDER.POPUP.PO_NUMBER' | translate}} </mat-header-cell>
      <mat-cell *matCellDef='let element'> {{element.poNumber}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef='status'>
      <mat-header-cell *matHeaderCellDef> {{module + '.PURCHASE_ORDER.POPUP.STATUS' | translate}}</mat-header-cell>
      <mat-cell *matCellDef='let element'>
        <span *ngIf="element.successful; else errorStatus">{{module + '.PURCHASE_ORDER.POPUP.SUCCESS' | translate}}</span>
        <ng-template #errorStatus>{{module + '.PURCHASE_ORDER.POPUP.ERROR' | translate}}</ng-template>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef='detail'>
      <mat-header-cell *matHeaderCellDef> {{module + '.PURCHASE_ORDER.POPUP.DETAIL' | translate}} </mat-header-cell>
      <mat-cell *matCellDef='let element' fxLayout="column" fxLayoutAlign="center start" fxFlexOffset="10px">
        <div *ngFor='let code of element.codes'>{{ module + '.PURCHASE_ORDER.POPUP.ERROR_CODE.' + (code || 'UNKNOWN') | translate }}</div>
        <span *ngIf="!element.successful && (!element.codes || !element.codes.length)"> {{ module + '.PURCHASE_ORDER.POPUP.ERROR_CODE.UNKNOWN' | translate }} </span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef='displayedColumns; sticky: true'></mat-header-row>
    <mat-row *matRowDef='let row; columns: displayedColumns;'></mat-row >
  </mat-table>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="center stretch">
  <button mat-raised-button mat-dialog-close (click)='close()'>{{ 'UTIL.BUTTONS.CLOSE' | translate }}</button>
  <button mat-raised-button mat-dialog-close (click)='export()'>{{ 'UTIL.BUTTONS.EXPORT' | translate }}</button>
</mat-dialog-actions>
